// utils/groupBy.js

/**
 * Group an array of objects by a key.
 *
 * @param {Array<Object>} items   The array to group (safe with null/undefined).
 * @param {string|function} key   Property name to group by, or a selector
 *                                 function `(item) => groupValue`.
 * @returns {Object<string, Array>}  Map of groupValue -> items in that group,
 *                                   preserving the original order within each group.
 */

export const groupBy = (items, key) => {
  const getGroupValue = typeof key === "function" ? key : (item) => item?.[key];

  return (items || []).reduce((groups, item) => {
    const value = getGroupValue(item);
    const bucket = value == null ? "" : String(value);
    (groups[bucket] = groups[bucket] || []).push(item);
    return groups;
  }, {});
};

export default groupBy;
